import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=fe7d2122&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"
import style0 from "./Payments.vue?vue&type=style&index=0&id=fe7d2122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7d2122",
  null
  
)

export default component.exports